import { INTEGRATION_PROVIDERS } from '@vy/types';
import { usePaddleCustomers } from '../../../../../hooks/requests/integrations';
import { useExternalCustomerSelection } from '../../hooks/use-external-customer-selection';

export const usePaddleCustomerSelection = () => {
  const { customers, ...rest } = useExternalCustomerSelection({
    provider: INTEGRATION_PROVIDERS.paddle,
    useCustomersHook: usePaddleCustomers,
  });

  return {
    paddleCustomers: customers,
    ...rest,
  };
};
